'use client'

import React, { useEffect, useState } from 'react'
import BottomNavbar from '@/src/components/mobile/bottomNavbar'
import { useRouter } from 'next/navigation'
import { Brand } from '@/src/utils/brand'
import { FLYIN } from '@/src/constants'
import { isMobileApp } from '@/src/utils/helper'

interface BottomNavbarContainerProps {
    brand: Brand
    selected?: number
}

const BottomNavbarContainer: React.FC<BottomNavbarContainerProps> = ({
    brand,
    selected = 0
}) => {
    const router = useRouter()
    const [selectedIndex, setSelectedIndex] = useState<number>(selected)
    const locale = 'en'
    const [hideForApp, setHideForApp] = useState(false)

    useEffect(() => {
        setHideForApp(isMobileApp())
    }, [])

    const handleSelectItem = (index: number, value: string) => {
        setSelectedIndex(index)

        let routingPath = ''

        switch (value) {
            case 'myAccount':
                routingPath = `/${locale}/account`
                break
            case 'home':
                routingPath = `/${locale}`
                break
            case 'hotels':
                routingPath =
                    brand === FLYIN
                        ? 'https://www.flyin.com/en/hotels'
                        : '/hotel'
                break
            case 'visa':
                routingPath = '/visa'
                break
            case 'offer':
                routingPath = `/${locale}/offers`
                break
        }

        if (routingPath) {
            if (routingPath.startsWith('http')) {
                window.location.href = routingPath
            } else {
                router.push(routingPath)
            }
        }
    }

    if (hideForApp) return null

    return (
        <BottomNavbar
            brand={brand}
            selected={selectedIndex}
            onSelectItem={handleSelectItem}
        />
    )
}

export default BottomNavbarContainer
